import type { ReactNode } from "react";

// Same scale as Row and Stack. It has to be a literal map: the old version
// built `gap-${gap}`, and Tailwind's JIT can't see a computed class name — so
// `gap="24"` produced a `gap-24` that was never generated and silently did
// nothing, while `gap="6"` happened to work only because Stack's map puts the
// literal `gap-6` in the scanned source.
const gapClasses: Record<number, string> = {
  0: "gap-0",
  0.5: "gap-0.5",
  1: "gap-1",
  1.5: "gap-1.5",
  2: "gap-2",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
};

interface SplitRowProps {
  left: ReactNode;
  right: ReactNode;
  /** Minimum separation between the two sides, in the Row/Stack scale (6 = 24px). */
  gap?: keyof typeof gapClasses;
}

/** A row with content justified between left and right */
export function SplitRow({ left, right, gap = 0 }: SplitRowProps) {
  return (
    <div
      className={`flex items-center justify-between ${gapClasses[gap] ?? "gap-0"}`}
    >
      {left}
      {right}
    </div>
  );
}
